import React, { Component } from 'react';
import { Tree } from 'primereact/tree';


class TreeDiagram extends Component {
    constructor(props) {
        super(props);
        this.state = { pastruct: null };
    }

    componentDidMount() {
        this.setState({
            pastruct: JSON.parse(this.props.pastruct),
        });
    }

    render() {
        // The layout prop doesn't exist anymore, it seems to be impossible to render a horizontal Tree in modern PrimeReact.
        return (
            <div>
                <Tree value={this.state.pastruct} layout={'horizontal'} />
            </div>
        );
    }
}

export default TreeDiagram;

